var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoAgents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3,24.56a1.2,1.2,0,0,1-.93-.37c-.16-.23,0-.62,0-.85l.26-.56a11.63,11.63,0,0,1,1.53-2.4,1.26,1.26,0,0,1,1.51-.24,4.38,4.38,0,0,1,.7.59,2.32,2.32,0,0,0,1.49.51H8a2.34,2.34,0,0,0,1.53-.49,4,4,0,0,1,.71-.6,1.19,1.19,0,0,1,1.38.24,10,10,0,0,1,1.44,2.44l.27.55a1.07,1.07,0,0,1,.08.84,1.11,1.11,0,0,1-.93.31Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.08,16.29a3.43,3.43,0,0,0,3.22-3.62V12.6a3.32,3.32,0,0,0-3.22-3.41H16a3.32,3.32,0,0,0-3.16,3.48v0A3.45,3.45,0,0,0,16.08,16.29Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79,19.61A3.44,3.44,0,0,0,11,16h0a3.32,3.32,0,0,0-3.13-3.5H7.79a3.31,3.31,0,0,0-3.2,3.42V16h0A3.43,3.43,0,0,0,7.79,19.61Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.24,13.09a3.51,3.51,0,0,0,3.23-3.61V9.41A3.33,3.33,0,0,0,24.24,6h0a3.31,3.31,0,0,0-3.16,3.44h0a3.51,3.51,0,0,0,3.22,3.65Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,17.05a1.17,1.17,0,0,0-1.34-.21,3.85,3.85,0,0,0-.7.58,2.43,2.43,0,0,1-1.53.51h-.49a2.42,2.42,0,0,1-1.55-.52,5.53,5.53,0,0,0-.7-.58,1.23,1.23,0,0,0-1.5.23,11.21,11.21,0,0,0-1.58,2.44l-.1.22a1.54,1.54,0,0,1,1.53.45,11.35,11.35,0,0,1,.76,1.06h5.55A5.82,5.82,0,0,1,20,17.05Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.21,16.7a6,6,0,0,1,4-1.48h0a6,6,0,0,1,5,2.78,1.07,1.07,0,0,0,.76-.31,1,1,0,0,0-.07-.85l-.28-.53a9.81,9.81,0,0,0-1.46-2.45,1.17,1.17,0,0,0-1.39-.23,3.65,3.65,0,0,0-.71.59,2.35,2.35,0,0,1-1.49.5h-.5a2.34,2.34,0,0,1-1.54-.52,4.07,4.07,0,0,0-.69-.55,1.25,1.25,0,0,0-1.5.24,10.5,10.5,0,0,0-1.54,2.41v.06A1.59,1.59,0,0,1,20.21,16.7Z",
    style: {
      fill: "#7e7e7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.27,16.4a4.8,4.8,0,1,0,4.79,4.81h0A4.81,4.81,0,0,0,24.27,16.4Zm3.67,4.79a3.64,3.64,0,0,1-.6,2l-5.06-5.05a3.51,3.51,0,0,1,2-.6A3.67,3.67,0,0,1,28,21.19Zm-7.33,0a3.66,3.66,0,0,1,.6-2l5.07,5.09a3.66,3.66,0,0,1-5.07-1.08h0a3.8,3.8,0,0,1-.55-2Z",
    style: {
      fill: "#e44817"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAgents);
export default __webpack_public_path__ + "static/media/no-agents.e9049fcf.svg";
export { ForwardRef as ReactComponent };